var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.5424 53.3493H9.46242C7.97742 53.3493 6.79492 52.1668 6.79492 50.6818V14.9868C6.79492 13.5018 7.97742 12.3193 9.46242 12.3193H56.5424C58.0274 12.3193 59.2099 13.5018 59.2099 14.9868V50.6818C59.2099 52.1393 58.0274 53.3493 56.5424 53.3493Z",
    stroke: "#3eb8aa",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0284 34.9784C36.2634 34.9784 38.8859 31.4817 38.8859 27.1684C38.8859 22.8551 36.2634 19.3584 33.0284 19.3584C29.7934 19.3584 27.1709 22.8551 27.1709 27.1684C27.1709 31.4817 29.7934 34.9784 33.0284 34.9784Z",
    stroke: "#3eb8aa",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6924 34.127C35.6924 34.127 36.7649 36.272 38.4149 36.657C40.0649 37.0145 44.8774 39.3245 45.3999 44.247",
    stroke: "#3eb8aa",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3042 34.127C30.3042 34.127 29.2317 36.272 27.5817 36.657C25.9317 37.0145 21.1192 39.3245 20.5967 44.247",
    stroke: "#3eb8aa",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdcard);
export default __webpack_public_path__ + "static/media/idcard.981a3ff29e6bc238506df8d2bfe60d68.svg";
export { ForwardRef as ReactComponent };